import React, { useState } from 'react'
import { AutoColumn } from '../../components/Column'
import styled from 'styled-components'
import {
  OLD_STAKING_REWARDS_INFO,
  STAKING_REWARDS_INFO,
  TURBO_STAKING_REWARDS_INFO,
  useOldStakingInfo,
  useStakingInfo,
  useTurboStakingInfo
} from '../../state/stake/hooks'
import { TYPE, ExternalLink } from '../../theme'
import PoolCard from '../../components/earn/PoolCard'
import { RowBetween } from '../../components/Row'
import { CardSection, DataCard, CardNoise, CardBGImage } from '../../components/earn/styled'
import Loader from '../../components/Loader'
import { useActiveWeb3React } from '../../hooks'

const PageWrapper = styled(AutoColumn)`
  max-width: 640px;
  width: 100%;
`

const TopSection = styled(AutoColumn)`
  max-width: 720px;
  width: 100%;
`

const PoolSection = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 10px;
  row-gap: 15px;
  width: 100%;
  justify-self: center;
  
  .message {
    color: ${({ theme }) => theme.text1};
    width: 100%;
    font-weight: bold;
    font-size: 1.1rem;
  }
`

const PoolSectionTabMenu = styled.ul`
  width: 100%;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 1.1rem;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.bg4};

  li {
    margin-right: 0.5rem;
    cursor: pointer;
    color: #fff;
    display: flex;
    justify-content: center;
    width: 100%;
    font-weight: bold;
    user-select: none;
    padding: 0.7rem;

    &.active {
      background-color: ${({ theme }) => theme.primary5};
    }

    &:last-child {
      margin-right: 0;
    }
  }
`

export default function Earn() {
  const { chainId } = useActiveWeb3React()
  const [activeTab, setActiveTab] = useState<string>('active')
  const stakingInfos = useStakingInfo()
  const turBoStakingInfos = useTurboStakingInfo()
  const oldStakingInfos = useOldStakingInfo()
  function setActiveTabFunction(tab: string) {
    setActiveTab(tab)
  }

  const DataRow = styled(RowBetween)`
    ${({ theme }) => theme.mediaWidth.upToSmall`
     flex-direction: column;
   `};
  `

  const stakingRewardsExist = Boolean(typeof chainId === 'number' && (STAKING_REWARDS_INFO[chainId]?.length ?? 0) > 0)
  const stakingTurboRewardsExist = Boolean(
    typeof chainId === 'number' && (TURBO_STAKING_REWARDS_INFO[chainId]?.length ?? 0) > 0
  )
  const stakingOldRewardsExist = Boolean(
    typeof chainId === 'number' && (OLD_STAKING_REWARDS_INFO[chainId]?.length ?? 0) > 0
  )

  return (
    <PageWrapper gap="lg" justify="center">
      <TopSection gap="md">
        <DataCard>
          <CardBGImage />
          <CardNoise />
          <CardSection>
            <AutoColumn gap="md">
              <RowBetween>
                <TYPE.white fontWeight={600}>YetiSwap liquidity mining</TYPE.white>
              </RowBetween>
              <RowBetween>
                <TYPE.white fontSize={14}>
                  Deposit your YetiSwap Liquidity Provider YTL tokens to receive YTS, the YetiSwap protocol governance
                  token.<br /><br />
                  Dont forget to move from finished pools to active pools.
                </TYPE.white>
              </RowBetween>{' '}
              <ExternalLink
                style={{ color: 'white', textDecoration: 'underline' }}
                href="https://www.yetiswap.app/introduction"
                target="_blank"
              >
                <TYPE.white fontSize={14}>Read more about YTS</TYPE.white>
              </ExternalLink>
            </AutoColumn>
          </CardSection>
          <CardBGImage />
          <CardNoise />
        </DataCard>
      </TopSection>

      <AutoColumn gap="lg" style={{ width: '100%', maxWidth: '720px' }}>
        <DataRow style={{ alignItems: 'baseline' }}>
          <TYPE.mediumHeader style={{ marginTop: '0.5rem' }}>Participating pools</TYPE.mediumHeader>
          <TYPE.black fontWeight={400}>The Rewards Never End!</TYPE.black>
        </DataRow>
        <PoolSectionTabMenu>
          <li onClick={() => setActiveTabFunction('active')} className={activeTab === 'active' ? 'active' : ''}>
            New Pools
          </li>
          <li onClick={() => setActiveTabFunction('closed')} className={activeTab === 'closed' ? 'active' : ''}>
            Finished Pools
          </li>
        </PoolSectionTabMenu>

        {activeTab === 'active' ? (
          <PoolSection>
            {stakingRewardsExist && stakingInfos?.length === 0 ? (
              <Loader style={{ margin: 'auto' }} />
            ) : !stakingRewardsExist ? (
              'No active rewards'
            ) : (
              stakingInfos?.map(stakingInfo => {
                // need to sort by added liquidity here
                return <PoolCard key={stakingInfo.stakingRewardAddress} stakingInfo={stakingInfo} />
              })
            )}
          </PoolSection>
        ) : (
          <PoolSection>
            <div className="message">Scroll down and check your stake</div>
            {stakingOldRewardsExist && oldStakingInfos?.length === 0 ? (
              <Loader style={{ margin: 'auto' }} />
            ) : !stakingRewardsExist ? (
              'No active rewards'
            ) : (
              oldStakingInfos?.map(stakingInfo => {
                // need to sort by added liquidity here
                return <PoolCard mode="old" key={stakingInfo.stakingRewardAddress} stakingInfo={stakingInfo} />
              })
            )}
            {stakingTurboRewardsExist && turBoStakingInfos?.length === 0 ? (
              <Loader style={{ margin: 'auto' }} />
            ) : !stakingRewardsExist ? (
              'No active rewards'
            ) : (
              turBoStakingInfos?.map(stakingInfo => {
                // need to sort by added liquidity here
                return <PoolCard mode="turbo" key={stakingInfo.stakingRewardAddress} stakingInfo={stakingInfo} />
              })
            )}
          </PoolSection>
        )}
      </AutoColumn>
    </PageWrapper>
  )
}
